// Public (unauthenticated) route prefixes — the single source of truth for the
// app's net-new public-route infra (ClickUp 868jxkz4p §10).
//
// Two places read this list and MUST stay in sync:
//   • App.js (AppRoutes)  — renders these paths OUTSIDE the app shell (no Sidebar
//     /Header, no protected <Routes> tree).
//   • AuthContext         — skips the "send logged-out users to the auth server"
//     redirect for these paths, so an unauthenticated visitor can actually load
//     them (and a logged-in visitor still gets their user resolved for gating).
//
// Add a prefix here to expose a new public surface; both behaviours follow.
export const PUBLIC_PATH_PREFIXES = ["/mentoring/invite/"];

export function isPublicPath(pathname = "") {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
